export const CHANGE_GRID_ITEM_STATE: string = "CHANGE_GRID_ITEM_STATE";
export const RESTART_GAME: string = "RESTART_GAME";
export const CHANGE_COLOR_SCHEME: string = "CHANGE_COLOR_SCHEME";
export const CHANGE_GAME_MODE: string = "CHANGE_GAME_MODE";